const weekDays = [
  {
    id: 1,
    code: 'monday',
    shortName: 'Lun',
    longName: 'Lunes',
  },
  {
    id: 2,
    code: 'tuesday',
    shortName: 'Mar',
    longName: 'Martes',
  },
  {
    id: 3,
    code: 'wednesday',
    shortName: 'Mie',
    longName: 'Miércoles',
  },
  {
    id: 4,
    code: 'thursday',
    shortName: 'Jue',
    longName: 'Jueves',
  },
  {
    id: 5,
    code: 'friday',
    shortName: 'Vie',
    longName: 'Viernes',
  },
  {
    id: 6,
    code: 'saturday',
    shortName: 'Sab',
    longName: 'Sábado',
  },
  {
    id: 0,
    code: 'sunday',
    shortName: 'Dom',
    longName: 'Domingo',
  },
];

export { weekDays };
